export enum WorkOrderCompanyRole {
  BROKER = 'broker',
  CLIENT = 'client',
  CONTRACTOR = 'contractor',
  INTERMEDIARY_BROKER = 'intermediary_broker'
}
